import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d9d4327"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "fixed ms-1",
  style: {"width":"150px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Multiselect, {
      modelValue: _ctx.selected,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
      options: _ctx.options,
      canClear: false,
      class: "multiselect-blue",
      style: {"width":"150px"},
      onSelect: _ctx.onSelect
    }, null, 8, ["modelValue", "options", "onSelect"])
  ]))
}